import { collect } from "@/lobby_common/api/game_gen.js";
import img1 from "@/assets/new/collection1.png";
import img2 from "@/assets/new/collection2.png";
import img3 from "@/assets/new/collection3.png";
import img4 from "@/assets/new/collection4.png";
export default {
  name: "collection",
  components: {},
  props: {
    gameGroupSid: {
      type: String,
      default: '',
    },
    isCollect: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "#fff",
    },
  },
  data() {
    return {
      curIsCollection: this.isCollect,
      img1,
      img2,
      img3,
      img4,
    };
  },
  computed: {
    taken() {
      return this.$store.getters.taken;
    },
  },
  watch: {
    isCollect: {
      immediate: true,
      handler(value, oldValue) {
        this.curIsCollection = value
      },
    },
  },
  async created() {},
  mounted() {},
  destroyed() {},
  methods: {
    async handleCollection(type) {
      let collection = this.$store.getters.getCollection;
      let unCollection = this.$store.getters.getUnCollection;

      const curType = type === "add" ? 'STATUS_BOOL_TRUE' : 'STATUS_BOOL_FALSE'
      if (!this.$store.getters.taken) {
        this.$Bus.$emit('showLogin')
        return;
      }
      const { code } = await collect({
        gameGroupSid: this.gameGroupSid,
        isCollect: curType, // 'add' 收藏  'del' 取消收藏
      });
      if (code === 0) {
        if (type === "add") {
          // 收藏
          // 收藏列表添加该游戏组ID
          if(!collection.includes(this.gameGroupSid)) {
            collection.unshift(this.gameGroupSid)
          }
          // 未收藏列表删除该游戏组ID
          unCollection = unCollection.filter(
            (v) => v !== this.gameGroupSid
          )
        } else {
          // 取消收藏
          // 未收藏列表添加该游戏组ID
          if(!unCollection.includes(this.gameGroupSid)) {
            unCollection.unshift(this.gameGroupSid)
          }
          // 收藏列表删除该游戏组ID
          collection = collection.filter(
            (v) => v !== this.gameGroupSid
          )
        }
        this.$store.commit("setCollection", collection);
        this.$store.commit("setUnCollection", unCollection);

        // 历史收藏页面 点击收藏从新请求接口
        if(String(this.$route.path) === '/history') {
          this.$Bus.$emit("getCollectionGameGroupAgain");
        }
      }
    },
    async handleCollectionPage() {
      const type = this.curIsCollection ? 'del' : 'add'
      this.handleCollection(type)
    }
  },
};
